import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Root Components
import { DataRoMaintenanceOrdersComponent } from './data-root/data-root.component';
import { CompaniesComponent } from './companies/companies.component';
import { FormCompanyComponent } from './companies/form-company/form-company.component';
import { ModalCompanyComponent } from './companies/modal-company/modal-company.component';
import { PlansComponent } from './plans/plans.component';
import { LogsComponent } from './logs/logs.component';

const RootComponents = [
  DataRoMaintenanceOrdersComponent,
  CompaniesComponent,
  FormCompanyComponent,
  ModalCompanyComponent,
  PlansComponent,
  LogsComponent
];

@NgModule({
  declarations: RootComponents,
  imports: [SharedModule],
  exports: RootComponents
})
export class RootModule { }
